// extracted by mini-css-extract-plugin
module.exports = {"content":"proofreader_content__a0e1k"};